import { Printer } from "lucide-react";
import { ReportKpis } from "./ReportKpis";
import { TrendChart } from "./TrendChart";
import { TeamChart } from "./TeamChart";
import { TimePatterns } from "./TimePatterns";
import { IssueBreakdown, NetworkMix } from "./Donuts";
import { WorstTable } from "./WorstTable";
import { ProviderScorecard } from "./ProviderScorecard";
import { ServerComparison } from "./ServerComparison";
import { ServerHealth } from "./ServerHealth";

export const Reports = ({ tests, allTests = tests, rangeLabel, teamLabel }) => (
  <div data-testid="reports-view">
    <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <div>
        <div className="font-display text-3xl tracking-wide">Network Performance Report</div>
        <div className="text-xs text-neutral-500" data-testid="report-scope">{rangeLabel} · {teamLabel} · generated {new Date().toLocaleString()}</div>
      </div>
      <button data-testid="print-report-button" onClick={() => window.print()} className="btn-primary px-4 py-2 text-xs flex items-center gap-2 no-print">
        <Printer className="w-4 h-4" /> Print / Save PDF
      </button>
    </div>
    <ReportKpis tests={tests} />
    <div className="grid grid-cols-1 lg:grid-cols-3 border-l border-t border-white/10">
      <ProviderScorecard tests={tests} />
      <ServerHealth tests={allTests} />
      <ServerComparison tests={tests} />
      <TrendChart tests={tests} />
      <TeamChart tests={tests} />
      <TimePatterns tests={tests} />
      <IssueBreakdown tests={tests} />
      <NetworkMix tests={tests} />
      <WorstTable title="Worst locations" tests={tests} keyFn={(t) => t.location?.city} testId="report-worst-locations" />
      <WorstTable title="ISP performance (worst first)" tests={tests} keyFn={(t) => t.isp} testId="report-worst-isps" />
      <WorstTable title="Test servers used" tests={tests} keyFn={(t) => (t.server_city ? `${t.server_city}${t.server_colo ? ` (${t.server_colo})` : ""}` : t.test_server === "cloudflare" ? "Cloudflare (unknown)" : "App server (USA)")} testId="report-test-servers" />
      <WorstTable title="Reps needing attention" tests={tests} keyFn={(t) => t.rep_name} testId="report-worst-reps" className="lg:col-span-3" />
    </div>
  </div>
);
